export default __webpack_public_path__ + "static/media/ic_arrowright16.b425521a.svg";